import style from '../../../assets/styles/panel.module.scss'

export const PanelListItemHeader = ({ titleDate }) => {
    return (
        <p className={style.dayTitle}>
            <span className="mx-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 18 18" fill="none"><path d="M14.25 4.5H3.75C2.92157 4.5 2.25 5.17157 2.25 6V14.25C2.25 15.0784 2.92157 15.75 3.75 15.75H14.25C15.0784 15.75 15.75 15.0784 15.75 14.25V6C15.75 5.17157 15.0784 4.5 14.25 4.5Z" stroke="#E42A3F" /><path d="M2.25 8.25H15.75" stroke="#E42A3F" strokeLinecap="round" /><path d="M6.75 12H11.25" stroke="#E42A3F" strokeLinecap="round" /><path d="M6 2.25V5.25" stroke="#E42A3F" strokeLinecap="round" /><path d="M12 2.25V5.25" stroke="#E42A3F" strokeLinecap="round" /></svg>
            </span>
            <span className="fw400 nfs-14">
                {titleDate && titleDate}
            </span>
        </p>
    );
}


export default PanelListItemHeader